import { render, staticRenderFns } from "./customPreview.vue?vue&type=template&id=70497a06&"
import script from "./customPreview.vue?vue&type=script&lang=js&"
export * from "./customPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports